import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Motion, spring } from 'react-motion';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import $ from 'jquery';
import { isElectronApp } from '../../services/crossPlatform/crossPlatformService';
import { getParameterByName } from '../../utils/routeUtils';

function removeNotAllowedCharacters(id) {
  const NOT_ALLOWED_REGEXPS = [/\//g, /\./g, /:/g];

  NOT_ALLOWED_REGEXPS.forEach(regexp => {
    id = id.toString().replace(regexp, '');
  });

  return id;
}

function reinsert(arr, from, to) {
  const _arr = arr.slice(0);
  const val = _arr[from];
  _arr.splice(from, 1);
  _arr.splice(to, 0, val);
  return _arr;
}

function clamp(n, min, max) {
  return Math.max(Math.min(n, max), min);
}

const STATIC_CARD = 'staticCardDragAndDrop';
const DRAG_PADDING_PX = 15;
const SPRING_SETTING = { stiffness: 120, damping: 17 };
const DRAG_AND_DROP_TIMEOUT_DELAY = 0;
// Same as $size-small in _variables.scss: below this width the view is considered mobile
const MOBILE_MAX_WIDTH_PX = 580;

function isMobileWidth() {
  return $(window).width() <= MOBILE_MAX_WIDTH_PX;
}

class DragAndDropContainer extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired, // id of d&d component
    cards: PropTypes.array, // list of cards
    containerClassName: PropTypes.string.isRequired, // class of d&d component
    renderCard: PropTypes.func.isRequired, // card
    renderStaticCard: PropTypes.func, // if this function is setted, the componenent render this static card
    rotation: PropTypes.number, // rotation card, in degrees
    handlerAfterMoveCard: PropTypes.func, // if this function is setted, the component call it after move a card
    dragActivated: PropTypes.bool, // active or not active drag and drop
    active: PropTypes.bool,
    cardId: PropTypes.string.isRequired, // object card id
    data: PropTypes.object, // custom data
    cardDimensions: PropTypes.func, // I f the size is setted, the component use it
    axisXActivated: PropTypes.bool,
    location: PropTypes.object
  };

  isDragging = false;
  listenersIncluded = false;
  performInitialResize = true;
  cardElementRef = null;

  //--------------------------------------------------------------------------------------------------------------------
  constructor(context, props) {
    super(context, props);

    this.resizeColumns = this.resizeColumns.bind(this);

    this.state = {
      mouse: [0, 0],
      delta: [0, 0], // difference between mouse and card pos, for dragging
      lastPress: null, // key of the last pressed component
      isPressed: false,
      order: [], // index: visual position. value: component key/id,
      cards: [], // index: visual position. value: component key/id,
      previousOrder: null,
      rowCol: 1, // RowCol default
      cardWidth: 0, // initial size, never mind...
      cardHeight: 0, // initial size, never mind...,
      clicked: false,
      isMobileView: isMobileWidth()
    };
  }

  //--------------------------------------------------------------------------------------------------------------------
  // Drag and drop is disabled on mobile view so touch gestures scroll the page instead of moving cards
  isDragEnabled() {
    return Boolean(this.props.dragActivated) && !this.state.isMobileView;
  }

  //--------------------------------------------------------------------------------------------------------------------
  componentDidMount() {
    const { cards } = this.props;
    this.setState({ cards });
    this.initOrder(cards);
    window.addEventListener('resize', this.resizeColumns);
  }

  //--------------------------------------------------------------------------------------------------------------------
  componentDidUpdate() {
    const { id, cards: propCards } = this.props;
    const { cards } = this.state;

    if (this.state.cards && !_.isEqual(cards, propCards)) {
      this.setState({ cards: propCards });
      this.initOrder(propCards);
    }

    if (!this.listenersIncluded && cards.length > 0 && this.isDragEnabled()) {
      let container = this.refs[id];
      container.addEventListener('touchmove', this.handleTouchMove.bind(this));
      container.addEventListener('touchend', this.handleMouseUp.bind(this));
      container.addEventListener('mousemove', this.handleMouseMove.bind(this));
      window.addEventListener('mouseup', this.handleMouseUp.bind(this));
      $(document).on('dragstart', function(e) {
        return false;
      });

      this.listenersIncluded = true;
    }

    if (this.cardElementRef) {
      this.performInitialResize = false;
      this.resizeColumns();
    }
  }

  //--------------------------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    const { id, dragActivated } = this.props;

    window.removeEventListener('resize', this.resizeColumns);

    let container = this.refs[id];
    if (container && dragActivated) {
      container.removeEventListener('touchmove', this.handleTouchMove.bind(this));
      container.removeEventListener('touchend', this.handleMouseUp.bind(this));
      container.removeEventListener('mousemove', this.handleMouseMove.bind(this));
      window.removeEventListener('mouseup', this.handleMouseUp.bind(this));
      $(document).off();
    }
  }

  //--------------------------------------------------------------------------------------------------------------------
  getCardId(card) {
    const { cardId } = this.props;
    let id = card[cardId];

    return removeNotAllowedCharacters(id);
  }

  //--------------------------------------------------------------------------------------------------------------------
  hasStaticCard() {
    const { renderStaticCard } = this.props;

    return Boolean(renderStaticCard);
  }

  //--------------------------------------------------------------------------------------------------------------------
  initOrder(cards) {
    let numElements = cards.length;
    let newOrder = [];

    if (numElements > 0) {
      newOrder = cards.map(c => this.getCardId(c));
    }

    this.setState({ order: newOrder });
  }

  //--------------------------------------------------------------------------------------------------------------------
  handleTouchStart(key, pressLocation, e) {
    this.handleMouseDown(key, pressLocation, e.touches[0]);
  }

  //--------------------------------------------------------------------------------------------------------------------
  handleTouchMove(e) {
    if (this.state.isPressed && this.isDragEnabled()) {
      e.preventDefault();
    }
    this.handleMouseMove(e.touches[0]);
  }

  //--------------------------------------------------------------------------------------------------------------------
  handleMouseMove({ pageX, pageY }) {
    const {
      order,
      lastPress,
      isPressed,
      delta: [dx, dy],
      rowCol,
      cardWidth,
      cardHeight,
      cards
    } = this.state;
    const { id } = this.props;
    const numElements = cards.length;

    if (numElements > 0 && this.isDragEnabled()) {
      let container = this.refs[id];
      let baseStyle = container.className.split(' ')[0];

      const mouse = [pageX - dx, pageY - dy];
      setTimeout(() => {
        if (isPressed && this.checkStartDrag(mouse)) {
          this.isDragging = true;
          container.className = baseStyle + ' cursor-move';
          const col = clamp(Math.round(mouse[0] / cardWidth), 0, rowCol - 1);
          const row = clamp(Math.round(mouse[1] / cardHeight), 0, Math.floor(numElements / rowCol));
          const index = row * rowCol + col;
          const newOrder = reinsert(order, order.indexOf(lastPress), index);

          let setState = { mouse: mouse };
          if (!_.isEqual(newOrder, order)) {
            setState.order = newOrder;
          }
          this.setState(setState);
        } else {
          this.isDragging = false;
          container.className = baseStyle;
        }
      }, DRAG_AND_DROP_TIMEOUT_DELAY);
    }
  }

  //--------------------------------------------------------------------------------------------------------------------
  handleMouseDown(key, [pressX, pressY], { pageX, pageY }) {
    this.setState({
      lastPress: key,
      isPressed: true,
      delta: [pageX - pressX, pageY - pressY],
      mouse: [pressX, pressY]
    });
  }

  //--------------------------------------------------------------------------------------------------------------------
  handleMouseUp() {
    const { order, previousOrder } = this.state;
    const { handlerAfterMoveCard, id } = this.props;

    let container = this.refs[id];
    if (container) {
      let newState = { isPressed: false, delta: [0, 0] };
      if (!_.isEqual(previousOrder, order) && this.isDragEnabled()) {
        newState.previousOrder = order;
        let newCardsOrder = this.getCardsSorted();
        // previousOrder defined to avoid calling on initial load
        if (handlerAfterMoveCard) {
          handlerAfterMoveCard(newCardsOrder);
        }
      }
      this.setState(newState);
    }
  }

  //--------------------------------------------------------------------------------------------------------------------
  checkStartDrag(mouse) {
    const { cardWidth, cardHeight } = this.state;

    let x;
    let y;
    [x, y] = mouse;
    let modX = x % cardWidth;
    let modY = y % cardHeight;

    return Math.abs(modX) > DRAG_PADDING_PX || Math.abs(modY) > DRAG_PADDING_PX;
  }

  //--------------------------------------------------------------------------------------------------------------------
  getCardsSorted() {
    const { order: newOrder, cards } = this.state;

    let itemsNewOrder = [];
    for (let itemOrderId of newOrder) {
      let nextCard = cards.find(c => {
        return this.getCardId(c) === itemOrderId;
      });
      itemsNewOrder.push(nextCard);
    }

    return itemsNewOrder;
  }

  //--------------------------------------------------------------------------------------------------------------------
  getCurrentContainerWidth() {
    const { id } = this.props;

    let currentContainerWidth = 1;
    if (this.refs && this.refs[id]) {
      const dragAndDropContainer = this.refs[id];
      let dragAndDropContainerNode = ReactDOM.findDOMNode(dragAndDropContainer);
      currentContainerWidth = dragAndDropContainerNode.clientWidth;
    } else {
      currentContainerWidth = $(window).width();
    }

    return currentContainerWidth;
  }

  //--------------------------------------------------------------------------------------------------------------------
  resizeColumns() {
    const { cardWidth, cardHeight, rowCol } = this.state;
    const { id, cardDimensions } = this.props;

    let newState = {};

    const isMobileView = isMobileWidth();
    if (isMobileView !== this.state.isMobileView) {
      newState.isMobileView = isMobileView;
    }

    if (this.cardElementRef && this.refs[id]) {
      let cardElement = $(`#${this.cardElementRef}`);
      let newWidth;
      let newHeight;

      if (cardDimensions) {
        let dimensions = cardDimensions();
        newWidth = dimensions.width;
        newHeight = dimensions.height;
      } else {
        newWidth = cardElement.width();
        newHeight = cardElement.height();
      }

      if (cardWidth !== newWidth || cardHeight !== newHeight) {
        newState.cardWidth = newWidth;
        newState.cardHeight = newHeight;
      }

      if (newWidth) {
        let currentContainerWidth = this.getCurrentContainerWidth();
        let newRowCol;

        if (currentContainerWidth <= MOBILE_MAX_WIDTH_PX) {
          newRowCol = 1;
        } else {
          newRowCol = Math.max(Math.floor(currentContainerWidth / newWidth), 1);
        }

        if (newRowCol !== rowCol) {
          newState.rowCol = newRowCol;
        }
      }
    }

    if (!_.isEmpty(newState)) {
      this.setState(newState);
    }
  }

  //--------------------------------------------------------------------------------------------------------------------
  getLayout(numElements) {
    const { rowCol, cardWidth, cardHeight } = this.state;
    return _.range(numElements).map(n => {
      const row = Math.floor(n / rowCol);
      const col = n % rowCol;
      return [cardWidth * col, cardHeight * row];
    });
  }

  //--------------------------------------------------------------------------------------------------------------------
  isAbalar() {
    const { location } = this.props;
    const param = !_.isNil(
      getParameterByName('jalied', location.search) || getParameterByName('unitId', location.search)
    );
    const isElectron = isElectronApp();
    return param && isElectron;
  }

  calculatePositioning(key) {
    const { order, lastPress, mouse, isPressed, cards } = this.state;
    const { rotation, axisXActivated } = this.props;
    const abalar = this.isAbalar();

    let style;
    let x;
    let y;
    const visualPosition = order.indexOf(key);
    [x, y] = mouse;

    if (key === lastPress && isPressed && this.checkStartDrag(mouse)) {
      let rotateZ = rotation ? rotation : 0;
      if (axisXActivated === false) {
        x = 0;
      }
      style = {
        translateX: x,
        translateY: y,
        rotateZ: rotateZ
      };
    } else {
      const numElements = cards.length;
      [x, y] = this.getLayout(numElements)[visualPosition];
      if (axisXActivated === false) {
        x = 0;
      }
      style = {
        translateX: abalar ? x : spring(x, SPRING_SETTING),
        translateY: abalar ? y : spring(y, SPRING_SETTING),
        rotateZ: 0
      };
    }

    return {
      style,
      visualPosition,
      x,
      y
    };
  }

  //--------------------------------------------------------------------------------------------------------------------
  getStaticCardLayout() {
    const { cards } = this.state;
    return this.getLayout(cards.length + 1)[cards.length];
  }

  //--------------------------------------------------------------------------------------------------------------------
  getTotalCards() {
    const { cards } = this.state;

    let totalCards = cards.length;
    if (this.hasStaticCard()) {
      totalCards++;
    }

    return totalCards;
  }

  //--------------------------------------------------------------------------------------------------------------------
  renderContent() {
    let content;
    const { cardHeight } = this.state;
    const { containerClassName, id } = this.props;
    const { rowCol } = this.state;

    let totalCards = this.getTotalCards();

    if (totalCards > 0) {
      let totalHeight = cardHeight * Math.ceil(totalCards / rowCol);
      content = (
        <div
          className={`${containerClassName}`}
          style={{ height: `${totalHeight}px`, position: 'relative' }}
          ref={`${id}`}
          id={`${id}`}
        >
          {this.renderContainer()}
        </div>
      );
    }
    return content;
  }

  //--------------------------------------------------------------------------------------------------------------------
  renderStaticCard() {
    const { renderStaticCard } = this.props;

    let x;
    let y;
    [x, y] = this.getStaticCardLayout();

    return (
      <div
        ref={STATIC_CARD}
        id={STATIC_CARD}
        key={STATIC_CARD}
        style={{
          WebkitTransform: `translate3d(${x}px, ${y}px, 0)`,
          transform: `translate3d(${x}px, ${y}px, 0)`,
          position: 'absolute'
        }}
      >
        {renderStaticCard()}
      </div>
    );
  }

  //--------------------------------------------------------------------------------------------------------------------
  renderContainer() {
    const { cards, order, lastPress, cardWidth } = this.state;
    const { renderCard, active, dragActivated, data, cardDimensions } = this.props;
    let items = [];
    order.forEach(key => {
      let item = cards.find(c => {
        return this.getCardId(c) === key;
      });
      let positioning = this.calculatePositioning(key);

      let elementRef = `cardElement${key}`;
      if (!this.cardElementRef) this.cardElementRef = elementRef;

      let position;
      let y = -1;

      if ((active === true && dragActivated === true) || active === undefined) {
        position = 'absolute';
      } else {
        position = 'relative';
        y = 0;
      }

      items.push(
        <Motion key={key} style={positioning.style}>
          {({ translateX, translateY, rotateZ }) => (
            <div
              ref={elementRef}
              id={elementRef}
              onMouseDown={this.handleMouseDown.bind(this, key, [positioning.x, positioning.y])}
              onTouchStart={this.handleTouchStart.bind(this, key, [positioning.x, positioning.y])}
              style={{
                transform: rotateZ ? `rotateZ(${rotateZ}deg)` : 'none',
                WebkitTransform: rotateZ ? `rotateZ(${rotateZ}deg)` : 'none',
                top: y === 0 ? y : translateY,
                left: translateX,
                // cardDimensions measures an element outside this wrapper; falling back to
                // self-measurement here (see resizeColumns) would make width feed back into itself.
                width: cardDimensions ? cardWidth : undefined,
                position: position,
                zIndex: key === lastPress && this.isDragging ? 99 : '',
                transition: 'z-index 0s linear',
                transitionDelay: '0.3s'
              }}
            >
              {renderCard({ key: key, item: item, data: data, isDragging: this.isDragging, order: order })}
            </div>
          )}
        </Motion>
      );
    });

    if (this.hasStaticCard()) {
      items.push(this.renderStaticCard());
      this.cardElementRef = STATIC_CARD;
    }

    return items;
  }

  //--------------------------------------------------------------------------------------------------------------------
  render() {
    return <div className="no-user-selection">{this.renderContent()}</div>;
  }
}

function mapStateToProps(state) {
  return {
    location: state.router.location
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(DragAndDropContainer);
